export interface ContactFormValues {
  name: string;
  email: string;
  message: string;
  policyAccepted: boolean;
}

export const ContactFormValuesOptions = {
  name: {
    required: { value: true, message: "Tell us your name" },
  },
  email: {
    required: { value: true, message: "Tell us your email" },
    pattern: {
      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
      message: "Invalid email address",
    },
  },
  message: {
    required: {
      value: true,
      message: "Write a message",
    },
  },
  policyAccepted: {
    required: {
      value: true,
      message: "Accept our privacy policy",
    },
  },
};